/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AuthInfo {
  /** The username of the user */
  username: string;

  /** The id of the user */
  sub: string;

  /** The issuer of the token */
  iss: string;

  /** The application id that provided the user */
  clientId: string;
}

export interface ChatIdAndOwner {
  /**
   * The id of the chat
   * @example 60b34d2f7c547f423ad17fcf
   */
  chatId: string;

  /**
   * The ids of the owners of the chat
   * @example ["60b34d2f7c547f423ad17fcf","60b34d2f7c547f423ad17fcf"]
   */
  owners: string[];
}

export interface ListOfChatsViewModel {
  /** An array of objects containing the id and owner of a chat */
  idAndOwners: ChatIdAndOwner[];
}

export interface Content {
  /**
   * The body of the message
   * @example some string
   */
  body: string;
}

export interface Message {
  /**
   * Id of the sender of the message
   * @example 886968133034
   */
  senderId: string;

  /** The content of the message */
  content: Content;

  /**
   * The timestamp of the message
   * @example 05-10-2020-18:00:02
   */
  timestamp: string;
}

export interface ChatGetViewModel {
  /**
   * The id of the chat
   * @example 60b34d2f7c547f423ad17fcf
   */
  chatId: string;

  /**
   * An array of owners
   * @example ["60b34d2f7c547f423ad17fcd","60b34d2f7c547f423ad17fcf"]
   */
  owners: string[];

  /** An array of messages */
  messages: Message;
}

export interface MessageListViewModel {
  /** A list of messages */
  messages: Message;
}

export interface CreateChatDto {
  /**
   * The ids of the chat owners
   * @example ["60b34d2f7c547f423ad17fcf","60b34d2f7c547f423ad17fcf"]
   */
  owners: string[];

  /** The content of the first message */
  content: Content;
}

export interface UpdateOwnersDto {
  /**
   * The ids of the owners that shall be added or removed.
   * @example ["60b34d2f7c547f423ad17fcf","60b34d2f7c547f423ad17fcf"]
   */
  owners: string[];
}

export interface ChatPutViewModel {
  /**
   * The id of the chat
   * @example 60b34d2f7c547f423ad17fcf
   */
  chatId: string;

  /**
   * An array of owners
   * @example ["60b34d2f7c547f423ad17fcf","60b34d2f7c547f423ad17fcf"]
   */
  owners: string[];
}

export interface AddMessageToChatDto {
  /** The message content */
  content: Content;
}

export interface MessageViewModel {
  /** A message */
  message: Message;
}

export interface ContactDto {
  /**
   * The email
   * @example info@mmmint.ai
   */
  email: string;

  /**
   * The phone
   * @example +4917672884125
   */
  phone: string;
}

export interface AddressDto {
  /**
   * The state
   * @example Niedersachsen
   */
  state?: string;

  /**
   * The street
   * @example Auf der Halle 25a
   */
  street: string;

  /**
   * The zip code
   * @example 49124
   */
  zip: string;

  /**
   * The city
   * @example Georgsmarienhütte
   */
  city: string;
}

export interface CreateUserDto {
  /**
   * The users first name
   * @example Max
   */
  firstName: string;

  /**
   * The users first name
   * @example Mustermann
   */
  lastName: string;

  /** The users name (in our case it have to be the Email address). */
  userName: string;

  /** The users contact details */
  contact: ContactDto;

  /** The users address */
  address: AddressDto;
}

export interface PermissionDto {
  /**
   * The type of the Resource
   * @example partner
   */
  type:
    | "partner"
    | "form"
    | "report"
    | "appraisal"
    | "manufacturer"
    | "machine"
    | "machine_attachment"
    | "organization"
    | "user"
    | "message";

  /**
   * The id of the Resource, e.g. Partner or Manufacturer
   * @example 6783420ß14239590
   */
  id: string;

  /**
   * The id of the Resource, e.g. Partner or Manufacturer
   * @example ["manage"]
   */
  action?: ("manage" | "create" | "read" | "update" | "delete")[];
}

export interface UserDocument {
  /** The users userName */
  userName: string;

  /** The users first name */
  firstName: string;

  /** The users first name */
  lastName: string;

  /** The users contact details */
  contact: object;

  /** The users address */
  address: object;

  /** The users external auth information */
  authInfo: object;

  /** The users authorization roles */
  roles: string[];

  /** The users Permission */
  permission: PermissionDto[];

  /**
   * The timestamps of the user
   * @example {"created":"2021-01-01T12:12:12.317Z","lastModified":"2021-01-01T12:12:12.317Z","modified":["2021-01-01T12:12:12.317Z","2021-01-01T12:12:12.000Z"]}
   */
  timestamps: object;
}

export interface UpdateUserDto {
  /**
   * The users first name
   * @example Max
   */
  firstName: string;

  /**
   * The users first name
   * @example Mustermann
   */
  lastName: string;

  /** The users contact details */
  contact: ContactDto;

  /** The users address */
  address: AddressDto;
}

export interface PromoteUserDto {
  /** The users authorization roles */
  roles: string[];
}

export interface SetUserTypeDto {
  /** The users authorization roles */
  type: string;
}

export interface UserRoleDto {
  /**
   * The users authorization roles
   * @example PARTNER
   */
  roles: ("ADMINISTRATOR" | "USER" | "PARTNER" | "EDITOR" | "APPRAISAL" | "DOCPHANT_ADMIN")[];
}

export interface UserPermissionDto {
  /** The users authorization roles */
  permission: PermissionDto[];
}

export interface UserAuthDto {
  /** The username */
  username: string;

  /** The password */
  password: string;
}

export interface AuthAccessToken {
  /**
   * The Bearer JWT `access_token` to authenticate to the API
   * @example jwttoken
   */
  access_token: string;

  /**
   * The accestoken expires in time (seconds)
   * @example 2000
   */
  expiresIn: number;

  /**
   * The refreshtoken
   * @example a refreshtoken
   */
  refreshToken?: string;

  /**
   * The idToken
   * @example a id token
   */
  idToken: string;
}

export interface GetTokenByRefreshTokenDto {
  /** The username (uuid) */
  uuidUsername: string;

  /** The refreshtoken */
  refreshToken: string;
}

export interface VerifyAuthDto {
  /** The username */
  username: string;

  /** The code */
  code: string;
}

export interface ConfirmPasswordDto {
  /** The username */
  username: string;

  /** The password */
  password: string;

  /** The code */
  code: string;
}

export interface ChangePasswordDto {
  /**
   * The previous password
   * @example your password
   */
  previousPassword: string;

  /**
   * The new password
   * @example your new password
   */
  proposedPassword: string;
}

export interface ChangePasswordIfRequiredDto {
  /**
   * The previous password
   * @example your password
   */
  previousPassword: string;

  /**
   * The new password
   * @example your new password
   */
  proposedPassword: string;

  /**
   * The username
   * @example info@mmmint.ai
   */
  username: string;
}

export interface ForgotPasswordDto {
  /** The username */
  username: string;
}

export interface TimestampDocument {
  /**
   * The created date
   * @format date-time
   */
  created: string;

  /**
   * The last modified date
   * @format date-time
   */
  lastModified: string;

  /** The modified date log */
  modified: string[];
}

export interface ImageDocument {
  /**
   * The id of the folder
   * @example abc123
   */
  folderName: string;

  /**
   * The name of the original image
   * @example abc123
   */
  name: string;
  url: string;

  /**
   * The type of the image
   * @example damage
   */
  type: string;

  /**
   * Is true if the picture is used in form, report or case.
   * @example damage
   */
  isUsed: boolean;

  /**
   * Is true if the picture is used in form, report or case.
   * @example damage
   */
  contactType: string;

  /** The timestamp */
  timestamp: TimestampDocument[];
}

export interface CoordinatesDto {
  /**
   * latitude coordinate
   * @example 52.20718647533527
   */
  lat: number;

  /**
   * latitude coordinate
   * @example 8.104300788327528
   */
  lng: number;
}

export interface AddressWithGeo {
  /**
   * The state
   * @example Niedersachsen
   */
  state?: string;

  /**
   * The street
   * @example Auf der Halle 25a
   */
  street: string;

  /**
   * The zip code
   * @example 49124
   */
  zip: string;

  /**
   * The city
   * @example Georgsmarienhütte
   */
  city: string;

  /** The city */
  geo: CoordinatesDto;
}

export interface OpeningHoursDto {
  /**
   * OpeningHours of monday
   * @example 08:00 bis 16:00
   */
  monday: string;

  /**
   * OpeningHours of tuesday
   * @example 08:00 bis 16:00
   */
  tuesday: string;

  /**
   * OpeningHours of wednesday
   * @example 08:00 bis 16:00
   */
  wednesday: string;

  /**
   * OpeningHours of thursday
   * @example 08:00 bis 16:00
   */
  thursday: string;

  /**
   * OpeningHours of friday
   * @example 08:00 bis 16:00
   */
  friday: string;

  /**
   * OpeningHours of saturday
   * @example 08:00 bis 16:00
   */
  saturday: string;

  /**
   * OpeningHours of sunday
   * @example 08:00 bis 16:00
   */
  sunday: string;
}

export interface WebsitesDto {
  /**
   * Text displayed for website link
   * @example www.mmmint.ai
   */
  text: string;

  /**
   * website link
   * @example https://www.mmmint.ai
   */
  link: string;
}

export interface EmailSettingsDto {
  /**
   * Desplay option for registrationresults in email
   * @example true
   */
  registrationShowResults: boolean;

  /**
   * Display option for ksr button in the email
   * @example true
   */
  registrationShowKsrButton: boolean;
}

export interface BookedServicesDto {
  /**
   * Registrationservice as booked service
   * @example true
   */
  registrationService: boolean;

  /**
   * Form as booked service
   * @example true
   */
  form: boolean;

  /**
   * Report as booked Service
   * @example true
   */
  report: boolean;

  /**
   * Payment as booked Service
   * @example true
   */
  payment: boolean;
}

export interface ReportScreenDto {
  /**
   * Defines the type of the screen
   * @example welcome
   */
  type:
    | "welcome"
    | "registration"
    | "damagelocator"
    | "overviewimage"
    | "componentimage"
    | "damagedetail"
    | "mileage"
    | "message"
    | "contactdetails"
    | "daterequest"
    | "closing";

  /** @example So einfach geht die fiktive Schadensabrechnung mit uns: */
  title: string;

  /** @example So einfach geht die fiktive Schadensabrechnung mit uns: */
  description: string;

  /**
   * Some specific Informations about the Screens Content
   * @example {}
   */
  content: object;
}

export interface ReportSettingsDto {
  /**
   * logoUrl for form and report
   * @example https://www.mmmint.ai/images/logo.png
   */
  logoUrl: string;

  /**
   * Header Image Url
   * @example https://www.mmmint.ai/images/logo.png
   */
  headerImageUrl: string;

  /**
   * FacIconUrl
   * @example https://www.mmmint.ai/images/logo.png
   */
  favIconUrl: string;

  /**
   * Colorcode for main color
   * @example #111111
   */
  firstColor: string;

  /**
   * Color code for second color
   * @example #123456
   */
  secondColor: string;

  /** @example ["welcome","registration","damagelocator","overviewimage","componentimage","damagedetail","mileage","message","daterequest","contactdetails","closing"] */
  screenOrder: (
    | "welcome"
    | "registration"
    | "damagelocator"
    | "overviewimage"
    | "componentimage"
    | "damagedetail"
    | "mileage"
    | "message"
    | "contactdetails"
    | "daterequest"
    | "closing"
  )[];
  screens: ReportScreenDto[];
}

export interface ParnterSettingsDto {
  /**
   * logoUrl for form and report
   * @example https://www.mmmint.ai/images/logo.png
   */
  logoUrl: string;

  /**
   * headerImageUrl of form or report
   * @example https://www.mmmint.ai/images/logo.png
   */
  headerImageUrl: string;

  /**
   * fav icon url
   * @example https://www.mmmint.ai/images/logo.png
   */
  favIconUrl: string;

  /**
   * Title of the Form
   * @example Digitale Schadensabrechnung
   */
  formTitle: string;

  /**
   * color code
   * @example #888888
   */
  color: string;

  /** contact */
  contact: ContactDto;

  /** Opening Hours of the Partner */
  openingHours: OpeningHoursDto;

  /** an array of website links and names */
  websites: WebsitesDto[];

  /**
   * Title o the Card in the text
   * @example Smart Repair
   */
  cardTitle: string;

  /**
   * Subtitle of the Text in the Card
   * @example Wir reparieren Ihr Auto
   */
  cardText: string;

  /**
   * Subtilte of the Card
   * @example Jetzt Angebot anfordern
   */
  cardSubtitle: string;

  /** Email Settings of the Partner */
  emailSettings: EmailSettingsDto;

  /** Services the Partner has booked */
  bookedServices: BookedServicesDto;

  /** Defines the Setting for the Report */
  reportSettings: ReportSettingsDto;

  /** Display option for the map on the landingpage */
  displayMap: boolean;

  /**
   * List of urls of the partner's landingpages
   * @example ['www.spotrepair-os.de','koopmann.azureedge.net','localhost:3000']
   */
  landingPageUrls: string[];
}

export interface CreatePartnerDto {
  /** The partners company user name */
  companyUsername: string;

  /** The partners company name */
  companyName: string;

  /** The partners Contact */
  contact: ContactDto;

  /** The partners Address */
  address: AddressWithGeo;

  /** The partners settings */
  settings: ParnterSettingsDto;
}

export type ObjectID = object;

export interface AssignedCaseDocument {
  /** The assigned case */
  case: ObjectID;

  /** The timestamp */
  timestamp: object;
}

export interface PartnerSettingsDocument {
  /** The link to the logo asset */
  logoUrl: string;

  /** The link to the header image asset */
  headerImageUrl: string;

  /** The link to the fav icon url asset */
  favIconUrl: string;

  /** The title of the form */
  formTitle: string;

  /** The color code of partner */
  color: string;

  /** The displayed contact details of partner */
  contact: object;

  /** The opening hours of a partner */
  openingHours: object;

  /** The displayed webistes of partner */
  websites: string[];

  /** The displayed webistes of partner */
  emailSettings: object;

  /** The displayed webistes of partner */
  bookedServices: object;

  /** The displayed webistes of partner */
  reportSettings: ReportSettingsDto;

  /** The title of the card */
  cardTitle: string;

  /** The subtitle of the card */
  cardSubtitle: string;

  /** The text of the card */
  cardText: string;

  /** The name of partner */
  companyName: string;

  /** Display option for the map on the landingpage */
  displayMap: boolean;

  /**
   * List of urls of the partner's landingpages
   * @example ['www.spotrepair-os.de','koopmann.azureedge.net','localhost:3000']
   */
  landingPageUrls: string[];
}

export interface PartnerDocument {
  /** The company username of a partner */
  companyUsername: string;

  /** The company name */
  companyName: string;

  /** The address */
  address: object;

  /** The contact */
  contact: object;

  /** The logo */
  logo: string;

  /** The editors */
  editors: ObjectID[];

  /** Assigned cases */
  assignedCases: AssignedCaseDocument[];

  /** Settings of partner */
  settings: PartnerSettingsDocument[];

  /**
   * The timestamps of the partner
   * @example {"created":"2021-01-01T12:12:12.317Z","lastModified":"2021-01-01T12:12:12.317Z","modified":["2021-01-01T12:12:12.317Z","2021-01-01T12:12:12.000Z"]}
   */
  timestamps: object;
}

export interface GeojsonPointViewmodel {
  /**
   * Type
   * @example Point
   */
  type: string;

  /**
   * coordinates
   * @example [52.9834857348,8.987653242]
   */
  coordinates: any[][];
}

export interface GeoJsonPartnerPropertiesViewmodel {
  /** @example MMM Intelligence Ug haftungsbeschränkt */
  companyname: string;

  /** @example Auf der Halle 25a */
  street: string;

  /** @example 49124 */
  zip: string;

  /** @example Georgsmarienhütte */
  city: string;

  /** @example +4917672884125 */
  phone: string;

  /** @example info@mmmmint.ai */
  email: string;
}

export interface GeoJsonPartnerFeatureViewmodel {
  /** @example Feature */
  type: string;

  /** Geojosn object for point */
  geometry: GeojsonPointViewmodel;

  /** Properties */
  properties: GeoJsonPartnerPropertiesViewmodel;
}

export interface PartnerGeojsonViewmodel {
  /** @example FeatureCollection */
  type: string;

  /** FeatureCollection */
  features: GeoJsonPartnerFeatureViewmodel[];
}

export interface UpdatePartnerDto {
  /** The partners company name */
  companyName: string;

  /** The partners Contact */
  contact: ContactDto;

  /** The partners Address */
  address: AddressWithGeo;

  /** The partners settings */
  settings: ParnterSettingsDto;
}

export interface UpdatePartnerEditorDto {
  /** The partners editors cases */
  editors: ObjectID;
}

export interface CreateFormDto {
  /** Your name */
  name: string;

  /** Your Contact Email */
  email: string;

  /** Your Contact Phone */
  phone: string;

  /** The Form Title */
  title: string;

  /** The Form Text */
  message: string;

  /**
   * Image of the registration.
   * @format binary
   */
  registration: File;

  /** Attachments. */
  images: File[];
}

export interface FormDocument {
  /** The id of the partner */
  partnerId: ObjectID;

  /** Your name */
  name: string;

  /** Your Contact Details */
  contact: object;

  /** The Form Text */
  title: string;

  /** The Form Title */
  message: string;

  /** Image of the registration. */
  registration: object;

  /** Attachments. */
  attachments: string[];

  /** registration Results. */
  registrationResults: object;

  /**
   * The timestamps of the partner
   * @example {"created":"2021-01-01T12:12:12.317Z","lastModified":"2021-01-01T12:12:12.317Z","modified":["2021-01-01T12:12:12.317Z","2021-01-01T12:12:12.000Z"]}
   */
  timestamps: object;
}

export interface ExportResultViewModel {
  /**
   * url of an export
   * @example https://devapimrfiktiv.blob.core.windows.net/6076fe6c6ed1cf97945cKqNCod68xL9YQsyg%3D
   */
  url: string;
}

export interface RegistrationDto {
  /**
   * firstname of registrationdocument
   * @example Max
   */
  firstname: object;

  /**
   * name of registrationdocument
   * @example Mustermann
   */
  name: object;

  /**
   * street of registrationdocument
   * @example Auf der Halle 25a
   */
  street: object;

  /**
   * zipCode of registrationdocument
   * @example 49124
   */
  zipCode: object;

  /**
   * city of registrationdocument
   * @example Georgsmarienhütte
   */
  city: object;

  /**
   * numberplate of registrationdocument
   * @example OS-PT 678
   */
  numberplate: object;

  /**
   * identificationnumber of registrationdocument
   * @example WVWZZZ1JW2W057177
   */
  identificationnumber: object;

  /**
   * huYear of registrationdocument
   * @example 2020
   */
  huYear: object;

  /**
   * huMonth of registrationdocument
   * @example 05
   */
  huMonth: object;

  /**
   * firstregistrationDay of registrationdocument
   * @example 05
   */
  firstregistrationDay: object;

  /**
   * firstregistrationMonth of registrationdocument
   * @example 05
   */
  firstregistrationMonth: object;

  /**
   * firstregistrationYear of registrationdocument
   * @example 2017
   */
  firstregistrationYear: object;

  /**
   * manufacturerNameCode of registrationdocument
   * @example 0005
   */
  manufacturerNameCode: object;

  /**
   * manufacturerTypeCode of registrationdocument
   * @example AHT00025
   */
  manufacturerTypeCode: object;

  /**
   * manufacturerName of registrationdocument
   * @example Volkswagen
   */
  manufacturerName: object;

  /**
   * manufacturerType of registrationdocument
   * @example Golf
   */
  manufacturerType: object;
}

export interface CreateProductDto {
  /**
   * If its an additonal productupgrade, parent is defined here
   * @example this-is-a-product-id
   */
  parent: string;

  /**
   * indicates whether the product can be purchased or not
   * @example true
   */
  isActive: boolean;

  /**
   * The price of the product in cents as number
   * @example 2999
   */
  priceInCents: number;

  /**
   * The title of the product
   * @example Digitaler Kostenvoranschlag
   */
  title: string;

  /**
   * Description of the product
   * @example schnellere Abwicklung
   */
  description: string;
}

export interface StripeProductViewmodel {
  /**
   * The stripe product id
   * @example this-is-a-product-id
   */
  productId: string;

  /**
   * This is a stripe price id
   * @example this-is-a-product-id
   */
  priceId: string;

  /**
   * The is a array of taxIds
   * @example ["this-is-a-product-id"]
   */
  taxIds: string[];
}

export interface ProductDocument {
  /**
   * The partner id
   * @example this-is-a-partner-id
   */
  partnerId: string;

  /**
   * The partner id
   * @example true
   */
  isActive: boolean;

  /**
   * The parent product id
   * @example this-is-a-product-id
   */
  parent: string;

  /**
   * The price of the product in ct
   * @example 999
   */
  priceInCents: number;

  /**
   * Titel of the product
   * @example Digitaler Kostenvoranschlag
   */
  title: string;

  /**
   * Description of the product
   * @example Komplett digital und güsntig zugleich
   */
  description: string;

  /** Informations about stripe */
  stripeProduct: StripeProductViewmodel;
}

export interface ProductViewmodel {
  /**
   * The product id
   * @example this-is-a-product-id
   */
  _id: string;

  /**
   * This product can only be used in combination with another product
   * @example this-is-a-product-id
   */
  parent?: string;

  /**
   * The price of the product including tax in cents.
   * @example 2999
   */
  price: number;

  /**
   * The title of the product
   * @example Digitaler Kostenvoranschlag
   */
  title: string;

  /**
   * A description of the product
   * @example schnellere Abwicklung
   */
  description: string;
}

export interface PdfDocument {
  /**
   * The id of the folder
   * @example abc123
   */
  folderName: string;

  /**
   * The name of the original pdf
   * @example abc123
   */
  name: string;
  url: string;

  /**
   * The type of the pdf
   * @example calculation
   */
  type: string;

  /** The timestamp */
  timestamp: TimestampDocument[];
}

export interface CreateReportImageDto {
  /**
   * The Type of the Image
   * @example damage
   */
  type: "damage" | "damageDetail" | "plate" | "cockpit" | "overview" | "registration" | "others";

  /**
   * Image for the Report.
   * @format binary
   */
  image: File;
}

export interface CreatedImageFromReportResponseDto {
  /**
   * The Id of the Image
   * @example abc123
   */
  imageId: string;
}

export interface CreateReportImageCollectionDto {
  /**
   * Your name
   * @example ["6058b76200570592f2b2e8fd"]
   */
  registrations: string[];

  /**
   * Your name
   * @example ["6058b76200570592f2b2e8fd"]
   */
  cockpits: string[];

  /**
   * Your name
   * @example ["6058b76200570592f2b2e8fd","6058b76200570592f2b2e8fd"]
   */
  damages: string[];

  /**
   * Your name
   * @example ["6058b76200570592f2b2e8fd","6058b76200570592f2b2e8fd"]
   */
  damagesDetail: string[];

  /**
   * Your name
   * @example ["6058b76200570592f2b2e8fd","6058b76200570592f2b2e8fd"]
   */
  overviews: string[];
}

export interface CreateReportDto {
  /**
   * Your name
   * @example Max Mustermann
   */
  customerName: string;

  /**
   * Customers Numberplate
   * @example OS-MM 2021
   */
  numberplate: string;

  /** Contact informations of the customer */
  customerContact: ContactDto;

  /** Contact informations of the customer */
  customerAddress: AddressDto;

  /**
   * The Form Text
   * @example Hello i have a damaged car.
   */
  message: string;

  /**
   * The Datepreference of the customer for a termin.
   * @example 2021-06-08T10:42:30.689Z
   */
  datePreference: string;

  /** The collection of the provided images. */
  images: CreateReportImageCollectionDto;

  /**
   * The damage locations provided by the customer via damage locator.
   * @example ["tireFrontLeft"]
   */
  damage: (
    | "tireFrontLeft"
    | "tireFrontRight"
    | "tireRearLeft"
    | "tireRearRight"
    | "doorFrontLeft"
    | "doorFrontRight"
    | "doorRearLeft"
    | "doorRearRight"
    | "bumperFront"
    | "bumperRear"
    | "fenderFrontLeft"
    | "fenderFrontRight"
    | "sidepanleRearLeft"
    | "sidepanelRearRight"
    | "roof"
    | "windshield"
    | "tailgate"
    | "engingeHood"
  )[];

  /**
   * MarketingOptIn to contact customer for marketing options.
   * @example true
   */
  marketingOptIn: boolean;
}

export interface ContactDocument {
  /** The email address */
  email: string;

  /** The phone number */
  phone: string;
}

export interface BaseImageSchema {
  /**
   * The name of the folder
   * @example abc123
   */
  folderName: string;

  /**
   * The name of the original image
   * @example abc123
   */
  name: string;
  url: string;

  /**
   * The type of the image
   * @example damage
   */
  type: string;

  /** The timestamp */
  timestamp: TimestampDocument;
}

export interface BaseCollectionSchema {
  /** The collection of the images. */
  registrations: BaseImageSchema[];

  /** The collection of the images. */
  cockpits: BaseImageSchema[];

  /** The collection of the images. */
  damages: string[];

  /** The collection of the images. */
  damagesDetail: BaseImageSchema[];

  /** The collection of the images. */
  overviews: BaseImageSchema[];

  /** The collection of the images. */
  plates: BaseImageSchema[];
}

export interface ReportDocument {
  /**
   * The id of the partner
   * @example abc123
   */
  partnerId: string;

  /**
   * Name of the customer
   * @example Max Mustermann
   */
  customerName: string;

  /**
   * The customers Numberplate
   * @example OS-MM 2021
   */
  numberplate: string;

  /** Contact Details of the customer */
  customerContact: ContactDocument;

  /** Address Details of the customer */
  customerAddress: AddressDto;

  /** The Detaildiscription of the Damage provided by the customer */
  message: string;

  /** registration Results. */
  registrationResults: RegistrationDto;

  /**
   * The timestamps of the partner
   * @example {"created":"2021-01-01T12:12:12.317Z","lastModified":"2021-01-01T12:12:12.317Z"}
   */
  timestamps: TimestampDocument[];

  /** The Datepreference of the customer for a termin. */
  datePreference: string;

  /** The collection of the images. */
  images: BaseCollectionSchema[];

  /**
   * The damage locations provided by the customer via damage locator.
   * @example ["tireFrontLeft"]
   */
  damage: (
    | "tireFrontLeft"
    | "tireFrontRight"
    | "tireRearLeft"
    | "tireRearRight"
    | "doorFrontLeft"
    | "doorFrontRight"
    | "doorRearLeft"
    | "doorRearRight"
    | "bumperFront"
    | "bumperRear"
    | "fenderFrontLeft"
    | "fenderFrontRight"
    | "sidepanleRearLeft"
    | "sidepanelRearRight"
    | "roof"
    | "windshield"
    | "tailgate"
    | "engingeHood"
  )[];

  /** Marketing-Opt-In Options */
  marketingOptIn: boolean;
}

export interface CreateNewsletterDto {
  /**
   * Your name
   * @example Max Mustermann
   */
  customerName: string;

  /**
   * Customers contact Email
   * @example Email address
   */
  subscriptionEmail: string;

  /** Contact informations of the customer */
  customerContact: ContactDto;

  /** Contact informations of the customer */
  customerAddress: AddressDto;

  /**
   * Marketing-Opt-In Options
   * @example ["mrfiktiv"]
   */
  interests: ("mrfiktiv" | "mmmint" | "workshopCustomer")[];

  /**
   * Marketing-Opt-In Options
   * @example mrfiktiv
   */
  firstContact: "mrfiktiv" | "mmmint" | "workshopCustomer";
}

export interface OptInConfirmation {
  /**
   * Subscription Email.
   * @example info@mmmmint.ai
   */
  subscribtionEmail: string;

  /**
   * Newsletter Id.
   * @example 5678347568093456
   */
  newsletterId: string;

  /**
   * ConfirmationMailSend.
   * @example true
   */
  confirmationMailSend: boolean;
}

export interface MarketingOptInDTO {
  /**
   * subscribestatus of the customer.
   * @example true
   */
  subscribeStatus: boolean;

  /**
   * verified the actual status.
   * @example true
   */
  verify: boolean;

  /**
   * Documents when the verified mail was opend.
   * @example ["2021-01-01T12:12:12.317Z"]
   */
  verifyMailOpened: string[];

  /**
   * verified the actual status.
   * @example ["2021-01-01T12:12:12.317Z"]
   */
  dateVerified: string[];

  /**
   * verified the actual status.
   * @example ["2021-01-01T12:12:12.317Z"]
   */
  dateUnsubscribed: string[];
}

export interface NewsletterDocument {
  /**
   * Contact Email Address
   * @example abc123
   */
  subscriptionEmail: string;

  /** Name of the customer */
  customerName: string;

  /** Contact Details of the customer */
  customerContact: ContactDocument;

  /** Address Details of the customer */
  customerAddress: AddressDto;

  /**
   * The id of the partner
   * @example abc123
   */
  userId: string;

  /**
   * The id of the partners
   * @example abc123
   */
  partnerIds: string[];

  /**
   * Interests of the customer.
   * @example ["mrfiktiv"]
   */
  interests: ("mrfiktiv" | "mmmint" | "workshopCustomer")[];

  /**
   * Channel of the first contact.
   * @example mrfiktiv
   */
  firstContact: "mrfiktiv" | "mmmint" | "report" | "form";

  /** Marketing-Opt-In Options */
  marketingOptIn: MarketingOptInDTO;

  /**
   * Private Key of customer
   * @example abc123
   */
  key: string;

  /** The timestamps of the partner */
  timestamps: TimestampDocument;
}

export interface AnalyticsCount {
  /**
   * Number of Entries
   * @example 250
   */
  count: number;
}

export interface AnalyticsCountGroupByPartner {
  /**
   * ID of partner
   * @example 123456567890
   */
  _id: string;

  /**
   * Name of partner
   * @example mmmint.ai
   */
  partnerName: string;

  /**
   * Number of Entries
   * @example 250
   */
  count: number;
}

export interface CreateAppraisalDto {
  /**
   * Customername
   * @example Max Mustermann
   */
  customerName: string;

  /**
   * Emailaddress of the customer
   * @example info@mmmint.ai
   */
  customerEmail: string;

  /**
   * Street of the customer inclusive house number
   * @example Auf der Halle 25 a
   */
  street: string;

  /**
   * City
   * @example Georgsmarienhütte
   */
  city: string;

  /**
   * Postcode
   * @example 49124
   */
  zip: string;

  /**
   * The mileage of the car in km.
   * @example 155368
   */
  mileage: string;

  /**
   * The identificationnumber of the car.
   * @example WVWZZZ1JW2W057177
   */
  identificationnumber: string;

  /**
   * The appraisal in pdf format.
   * @format binary
   */
  appraisal: File;
}

export interface AppraisalIdViewmodel {
  /**
   * appraisalId
   * @example 60720800d5218e7b9531bf8f
   */
  appraisalId: string;
}

export interface AppraisalNotifyPartnerDto {
  /**
   * PartnerId
   * @example 60720800d5218e7b9531bf8f
   */
  partnerId: string;
}

export interface BasePdfViewmodel {
  /**
   * name of the folder
   * @example appraisals
   */
  folderName: string;

  /**
   * metada of the pdf
   * @example {"originalName":"MISQ-RatingDisplays-Forthcoming.pdf","size":992301}
   */
  metaData: object;

  /**
   * name of the file
   * @example 4673985834961234nf
   */
  name: string;

  /**
   * Url of the file
   * @example https://devapimrfiktiv.blob.core.windows.net/appraisals/71e8c062bfae5ffb71214932.pdf
   */
  url: string;

  /**
   * Type of the Pdf
   * @example appraisal
   */
  type: "calculation" | "invoice" | "appraisal" | "documentation";

  /**
   * The timestamps of the partner
   * @example {"created":"2021-01-01T12:12:12.317Z","lastModified":"2021-01-01T12:12:12.317Z"}
   */
  timestamp: TimestampDocument[];
}

export interface AppraisalViewmodel {
  /**
   * partnerId
   * @example 60720800d5218e7b9531bf8f
   */
  partnerId: string;

  /**
   * notifyStatus
   * @example true
   */
  notifyStatus: boolean;

  /**
   * customerName
   * @example Max Mustermann
   */
  customerName: string;

  /**
   * Email Adress of Customer
   * @example max.mustermann@mmmint.ai
   */
  customerEmail: string;

  /** Adress with Geo Information */
  customerAddress: AddressWithGeo;

  /**
   * Mileage of the car
   * @example 23746
   */
  mileage: string;

  /**
   * Identificationnumer
   * @example 23746
   */
  identificationnumber: string;

  /** Attached PDF */
  appraisal: BasePdfViewmodel;

  /**
   * The timestamps
   * @example {"created":"2021-01-01T12:12:12.317Z","lastModified":"2021-01-01T12:12:12.317Z"}
   */
  timestamps: TimestampDocument[];
}

export interface PaymentDto {
  /**
   * The name of the customer
   * @example Max Mustermann
   */
  customerName: string;

  /** Contact informations of the customer */
  customerContact: ContactDto;

  /** Contact informations of the customer */
  customerAddress: AddressDto;

  /**
   * The id of the products you want to buy
   * @example ["this is a product Id"]
   */
  productIds: string[];
}

export interface PaymentViewmodel {
  /**
   * The payment id
   * @example this-is-a-payment-id
   */
  id: string;

  /**
   * The checkouturl id
   * @example this-is-a-checkouturl-id
   */
  checkoutUrl: string;
}

export interface ManufacturerDto {
  /**
   * Your name
   * @example Maschinenhersteller XYZ
   */
  name: string;

  /**
   * Your url to logo
   * @example www.url-to-your-logo.com
   */
  logoUrl: string;

  /** Address informations of the customer */
  address: AddressDto;

  /** Contact informations of the manufacturer */
  contact: ContactDto;
}

export interface ManufacturerViewmodel {
  /** The id of the manufacturer */
  id: string;

  /** The name */
  name: string;

  /** The address */
  address: AddressDto;

  /** The contact */
  contact: ContactDto;

  /** The Url of the Logo */
  logoUrl: string;

  /**
   * The timestamps of the partner
   * @example {"created":"2021-01-01T12:12:12.317Z","lastModified":"2021-01-01T12:12:12.317Z","modified":["2021-01-01T12:12:12.317Z","2021-01-01T12:12:12.000Z"]}
   */
  timestamps: object;
}

export interface MachineWeightDto {
  /**
   * The unit of the weight.
   * @example kg
   */
  unit: "t" | "dt" | "kg" | "g" | "mg";

  /**
   * Your amount of the weight.
   * @example 99
   */
  amount: number;
}

export interface MachineDimensionDto {
  /**
   * The unit of the dimension.
   * @example mm
   */
  unit: "km" | "m" | "dm" | "cm" | "mm";

  /**
   * height of the machine
   * @example 99
   */
  height: number;

  /**
   * width of the machine
   * @example 99
   */
  width: number;

  /**
   * depth of the machine
   * @example 99
   */
  depth: number;
}

export interface MachineDto {
  /**
   * The type of the machine.
   * @example other
   */
  machineType:
    | "machine"
    | "changeable_equipment"
    | "safteycomponent"
    | "load_carrying_equipment"
    | "chains"
    | "cardanshafts"
    | "incomplete_machine"
    | "other";

  /**
   * The name of the machine.
   * @example Umkantmaschine
   */
  machineName: string;

  /**
   * Variante der Maschine
   * @example Variante 0.5
   */
  variant: string;

  /**
   * Beschreibung
   * @example Maschine zum Umkanten von Stahl.
   */
  description: string;

  /** The Weight of the Machine */
  weight: MachineWeightDto;

  /** The partners Contact */
  dimension: MachineDimensionDto;

  /**
   * The unit of the weight.
   * @example inprocess
   */
  status: "inprocess" | "corrected" | "activated" | "disabled";
}

export interface MachineViewmodel {
  /**
   * The type of the machine.
   * @example other
   */
  machineType:
    | "machine"
    | "changeable_equipment"
    | "safteycomponent"
    | "load_carrying_equipment"
    | "chains"
    | "cardanshafts"
    | "incomplete_machine"
    | "other";

  /**
   * The name of the machine.
   * @example Umkantmaschine
   */
  machineName: string;

  /**
   * Variante der Maschine
   * @example Variante 0.5
   */
  variante: string;

  /**
   * Beschreibung
   * @example Maschine zum Umkanten von Stahl.
   */
  description: string;

  /** The Weight of the Machine */
  weight: MachineWeightDto;

  /** The partners Contact */
  dimension: MachineDimensionDto;

  /**
   * The unit of the weight.
   * @example progress
   */
  status: "inprocess" | "corrected" | "activated" | "disabled";

  /** The id of the manufacturer */
  id: string;

  /**
   * The timestamps of the partner
   * @example {"created":"2021-01-01T12:12:12.317Z","lastModified":"2021-01-01T12:12:12.317Z","modified":["2021-01-01T12:12:12.317Z","2021-01-01T12:12:12.000Z"]}
   */
  timestamps: object;

  /**
   * The id of the manufacturer.
   * @example 507f1f77bcf86cd799439011
   */
  manufacturer: string;

  /**
   * IDs of Documentations.
   * @example ["507f1f77bcf86cd799439011"]
   */
  machineAttachment: string[];
}

export interface MachineAttachmentViewmodel {
  /**
   * The id of the Documentation.
   * @example xyz
   */
  id: string;

  /**
   * The name of the Documentation.
   * @example Betriebsanleitung
   */
  name: string;

  /**
   * A Description for the Documentation.
   * @example Betriebsanleitung xyz
   */
  descripton: string;

  /**
   * The type of the documentation.
   * @example piecelist
   */
  attachmentType:
    | "operating_instructions"
    | "eg_conformity_declaration"
    | "user_info"
    | "risk_assessment"
    | "applied_standards"
    | "machined_rawing"
    | "test_results"
    | "wiring_diagram"
    | "piecelist"
    | "technical_inspection_report"
    | "purchase_part_documentation"
    | "signature_list"
    | "technical_spezification"
    | "regulations"
    | "test_protocol"
    | "other";

  /**
   * The status of the Document
   * @example activated
   */
  status: "inprocess" | "corrected" | "activated" | "disabled";

  /**
   * The internal code/id etc of the Documentation.
   * @example BA_8123977_VENTILATOR
   */
  attachmentCode: string;

  /**
   * The editors of the Documents.
   * @example Max Mustermann
   */
  editor: string;

  /**
   * Language of the Document.
   * @example de
   */
  language:
    | "af"
    | "ak"
    | "sq"
    | "am"
    | "ar"
    | "hy"
    | "as"
    | "az"
    | "bm"
    | "bn"
    | "eu"
    | "be"
    | "bs"
    | "br"
    | "bg"
    | "my"
    | "ca"
    | "ce"
    | "zh"
    | "zh_Hans"
    | "zh_Hant"
    | "cu"
    | "kw"
    | "co"
    | "hr"
    | "cs"
    | "da"
    | "nl"
    | "nl_BE"
    | "dz"
    | "en"
    | "en_AU"
    | "en_CA"
    | "en_GB"
    | "en_US"
    | "eo"
    | "et"
    | "ee"
    | "fo"
    | "fi"
    | "fr"
    | "fr_CA"
    | "fr_CH"
    | "ff"
    | "gl"
    | "lg"
    | "ka"
    | "de"
    | "de_AT"
    | "de_CH"
    | "el"
    | "gu"
    | "ht"
    | "ha"
    | "he"
    | "hi"
    | "hu"
    | "is"
    | "ig"
    | "id"
    | "ia"
    | "ga"
    | "it"
    | "ja"
    | "jv"
    | "kl"
    | "kn"
    | "ks"
    | "kk"
    | "km"
    | "ki"
    | "rw"
    | "ko"
    | "ku"
    | "ky"
    | "lo"
    | "la"
    | "lv"
    | "ln"
    | "lt"
    | "lu"
    | "lb"
    | "mk"
    | "mg"
    | "ms"
    | "ml"
    | "mt"
    | "gv"
    | "mi"
    | "mr"
    | "mn"
    | "ne"
    | "nd"
    | "se"
    | "nb"
    | "nn"
    | "ny"
    | "or"
    | "om"
    | "os"
    | "ps"
    | "fa"
    | "fa_AF"
    | "pl"
    | "pt"
    | "pt_BR"
    | "pt_PT"
    | "pa"
    | "qu"
    | "ro"
    | "ro_MD"
    | "rm"
    | "rn"
    | "ru"
    | "sm"
    | "sg"
    | "sa"
    | "gd"
    | "sr"
    | "sn"
    | "ii"
    | "sd"
    | "si"
    | "sk"
    | "sl"
    | "so"
    | "st"
    | "es"
    | "es_ES"
    | "es_MX"
    | "su"
    | "sw"
    | "sw_CD"
    | "sv"
    | "tg"
    | "ta"
    | "tt"
    | "te"
    | "th"
    | "bo"
    | "ti"
    | "to"
    | "tr"
    | "tk"
    | "uk"
    | "ur"
    | "ug"
    | "uz"
    | "vi"
    | "vo"
    | "cy"
    | "fy"
    | "wo"
    | "xh"
    | "yi"
    | "yo"
    | "zu";

  /** The file */
  file: BasePdfViewmodel;

  /**
   * The timestamps of the partner
   * @example {"created":"2021-01-01T12:12:12.317Z","lastModified":"2021-01-01T12:12:12.317Z","modified":["2021-01-01T12:12:12.317Z","2021-01-01T12:12:12.000Z"]}
   */
  timestamps: object;

  /**
   * Id of the manufacturer.
   * @example Betriebsanleitung
   */
  manufacturer: string;

  /**
   * The id of the machines.
   * @example ["this_is_a_id"]
   */
  machines: string[];
}

export interface MachineViewmodelWithManufacturerAndAttachment {
  /**
   * The type of the machine.
   * @example other
   */
  machineType:
    | "machine"
    | "changeable_equipment"
    | "safteycomponent"
    | "load_carrying_equipment"
    | "chains"
    | "cardanshafts"
    | "incomplete_machine"
    | "other";

  /**
   * The name of the machine.
   * @example Umkantmaschine
   */
  machineName: string;

  /**
   * Variante der Maschine
   * @example Variante 0.5
   */
  variante: string;

  /**
   * Beschreibung
   * @example Maschine zum Umkanten von Stahl.
   */
  description: string;

  /** The Weight of the Machine */
  weight: MachineWeightDto;

  /** The partners Contact */
  dimension: MachineDimensionDto;

  /**
   * The unit of the weight.
   * @example progress
   */
  status: "inprocess" | "corrected" | "activated" | "disabled";

  /** The id of the manufacturer */
  id: string;

  /**
   * The timestamps of the partner
   * @example {"created":"2021-01-01T12:12:12.317Z","lastModified":"2021-01-01T12:12:12.317Z","modified":["2021-01-01T12:12:12.317Z","2021-01-01T12:12:12.000Z"]}
   */
  timestamps: object;

  /** The manufacturer. */
  manufacturer: ManufacturerViewmodel;

  /** List of Documentation Documents */
  machineAttachment: MachineAttachmentViewmodel[];
}

export interface AddMachineAttachmentDto {
  /**
   * IDs of Documentations.
   * @example 507f1f77bcf86cd799439011
   */
  machineAttachmentId: string;
}

export interface MachineViewmodelWithManufacturer {
  /**
   * The type of the machine.
   * @example other
   */
  machineType:
    | "machine"
    | "changeable_equipment"
    | "safteycomponent"
    | "load_carrying_equipment"
    | "chains"
    | "cardanshafts"
    | "incomplete_machine"
    | "other";

  /**
   * The name of the machine.
   * @example Umkantmaschine
   */
  machineName: string;

  /**
   * Variante der Maschine
   * @example Variante 0.5
   */
  variante: string;

  /**
   * Beschreibung
   * @example Maschine zum Umkanten von Stahl.
   */
  description: string;

  /** The Weight of the Machine */
  weight: MachineWeightDto;

  /** The partners Contact */
  dimension: MachineDimensionDto;

  /**
   * The unit of the weight.
   * @example progress
   */
  status: "inprocess" | "corrected" | "activated" | "disabled";

  /** The id of the manufacturer */
  id: string;

  /**
   * The timestamps of the partner
   * @example {"created":"2021-01-01T12:12:12.317Z","lastModified":"2021-01-01T12:12:12.317Z","modified":["2021-01-01T12:12:12.317Z","2021-01-01T12:12:12.000Z"]}
   */
  timestamps: object;

  /** The id of the manufacturer. */
  manufacturer: ManufacturerViewmodel;

  /**
   * IDs of Documentations.
   * @example ["507f1f77bcf86cd799439011"]
   */
  machineAttachment: string[];
}

export interface MachineAttachmentDto {
  /**
   * The name of the Documentation.
   * @example Betriebsanleitung
   */
  name: string;

  /**
   * A Description for the Documentation.
   * @example Betriebsanleitung xyz
   */
  descripton: string;

  /**
   * The type of the documentation.
   * @example piecelist
   */
  attachmentType:
    | "operating_instructions"
    | "eg_conformity_declaration"
    | "user_info"
    | "risk_assessment"
    | "applied_standards"
    | "machined_rawing"
    | "test_results"
    | "wiring_diagram"
    | "piecelist"
    | "technical_inspection_report"
    | "purchase_part_documentation"
    | "signature_list"
    | "technical_spezification"
    | "regulations"
    | "test_protocol"
    | "other";

  /**
   * The status of the Document
   * @example inprocess
   */
  status: "inprocess" | "corrected" | "activated" | "disabled";

  /**
   * The internal code/id etc of the Documentation.
   * @example BA_8123977_VENTILATOR
   */
  attachmentCode: string;

  /**
   * The editors of the Documents.
   * @example Max Mustermann
   */
  editor: string;

  /**
   * Language of the Document.
   * @example de
   */
  language:
    | "af"
    | "ak"
    | "sq"
    | "am"
    | "ar"
    | "hy"
    | "as"
    | "az"
    | "bm"
    | "bn"
    | "eu"
    | "be"
    | "bs"
    | "br"
    | "bg"
    | "my"
    | "ca"
    | "ce"
    | "zh"
    | "zh_Hans"
    | "zh_Hant"
    | "cu"
    | "kw"
    | "co"
    | "hr"
    | "cs"
    | "da"
    | "nl"
    | "nl_BE"
    | "dz"
    | "en"
    | "en_AU"
    | "en_CA"
    | "en_GB"
    | "en_US"
    | "eo"
    | "et"
    | "ee"
    | "fo"
    | "fi"
    | "fr"
    | "fr_CA"
    | "fr_CH"
    | "ff"
    | "gl"
    | "lg"
    | "ka"
    | "de"
    | "de_AT"
    | "de_CH"
    | "el"
    | "gu"
    | "ht"
    | "ha"
    | "he"
    | "hi"
    | "hu"
    | "is"
    | "ig"
    | "id"
    | "ia"
    | "ga"
    | "it"
    | "ja"
    | "jv"
    | "kl"
    | "kn"
    | "ks"
    | "kk"
    | "km"
    | "ki"
    | "rw"
    | "ko"
    | "ku"
    | "ky"
    | "lo"
    | "la"
    | "lv"
    | "ln"
    | "lt"
    | "lu"
    | "lb"
    | "mk"
    | "mg"
    | "ms"
    | "ml"
    | "mt"
    | "gv"
    | "mi"
    | "mr"
    | "mn"
    | "ne"
    | "nd"
    | "se"
    | "nb"
    | "nn"
    | "ny"
    | "or"
    | "om"
    | "os"
    | "ps"
    | "fa"
    | "fa_AF"
    | "pl"
    | "pt"
    | "pt_BR"
    | "pt_PT"
    | "pa"
    | "qu"
    | "ro"
    | "ro_MD"
    | "rm"
    | "rn"
    | "ru"
    | "sm"
    | "sg"
    | "sa"
    | "gd"
    | "sr"
    | "sn"
    | "ii"
    | "sd"
    | "si"
    | "sk"
    | "sl"
    | "so"
    | "st"
    | "es"
    | "es_ES"
    | "es_MX"
    | "su"
    | "sw"
    | "sw_CD"
    | "sv"
    | "tg"
    | "ta"
    | "tt"
    | "te"
    | "th"
    | "bo"
    | "ti"
    | "to"
    | "tr"
    | "tk"
    | "uk"
    | "ur"
    | "ug"
    | "uz"
    | "vi"
    | "vo"
    | "cy"
    | "fy"
    | "wo"
    | "xh"
    | "yi"
    | "yo"
    | "zu";

  /**
   * The appraisal in pdf format.
   * @format binary
   */
  file: File;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded"
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer"
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(key => "undefined" !== typeof query[key]);
    return keys
      .map(key => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
            ? JSON.stringify(property)
            : `${property}`
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input)
  };

  private mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    };
  }

  private createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        ...(requestParams.headers || {})
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body)
    }).then(async response => {
      const r = response as HttpResponse<T, E>;
      r.data = (null as unknown) as T;
      r.error = (null as unknown) as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then(data => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch(e => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title mrfiktiv
 * @version 0.10.1
 * @contact
 *
 * The mrfiktiv API description
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * No description
     *
     * @name AppControllerGetAuthInfo
     * @summary Get users authentication information
     * @request GET:/v1/authInfo
     * @secure
     */
    appControllerGetAuthInfo: (params: RequestParams = {}) =>
      this.request<AuthInfo, void>({
        path: `/v1/authInfo`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name AppControllerGetAuthRequestUser
     * @summary Get users authentication information
     * @request GET:/v1/authRequestUser
     * @secure
     */
    appControllerGetAuthRequestUser: (params: RequestParams = {}) =>
      this.request<AuthInfo, void>({
        path: `/v1/authRequestUser`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags health
     * @name HealthControllerCheck
     * @summary Get the health status of the API
     * @request GET:/v1/health
     */
    healthControllerCheck: (params: RequestParams = {}) =>
      this.request<
        {
          status?: string;
          info?: Record<string, { status?: string }>;
          error?: Record<string, { status?: string }>;
          details?: Record<string, { status?: string }>;
        },
        {
          status?: string;
          info?: Record<string, { status?: string }>;
          error?: Record<string, { status?: string }>;
          details?: Record<string, { status?: string }>;
        }
      >({
        path: `/v1/health`,
        method: "GET",
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags health
     * @name HealthControllerCheckApp
     * @summary Get the health status of the app
     * @request GET:/v1/health/app
     */
    healthControllerCheckApp: (params: RequestParams = {}) =>
      this.request<
        {
          status?: string;
          info?: Record<string, { status?: string }>;
          error?: Record<string, { status?: string }>;
          details?: Record<string, { status?: string }>;
        },
        {
          status?: string;
          info?: Record<string, { status?: string }>;
          error?: Record<string, { status?: string }>;
          details?: Record<string, { status?: string }>;
        }
      >({
        path: `/v1/health/app`,
        method: "GET",
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags health
     * @name HealthControllerCheckWebsites
     * @summary Get the health status of the websites
     * @request GET:/v1/health/websites
     */
    healthControllerCheckWebsites: (params: RequestParams = {}) =>
      this.request<
        {
          status?: string;
          info?: Record<string, { status?: string }>;
          error?: Record<string, { status?: string }>;
          details?: Record<string, { status?: string }>;
        },
        {
          status?: string;
          info?: Record<string, { status?: string }>;
          error?: Record<string, { status?: string }>;
          details?: Record<string, { status?: string }>;
        }
      >({
        path: `/v1/health/websites`,
        method: "GET",
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags message
     * @name MessageControllerGetChatsFromUserId
     * @summary Gets the chats belonging to the user
     * @request GET:/v1/message/owner
     * @secure
     */
    messageControllerGetChatsFromUserId: (params: RequestParams = {}) =>
      this.request<ListOfChatsViewModel, void>({
        path: `/v1/message/owner`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags message
     * @name MessageControllerGetChatByChatId
     * @summary Gets chat by id
     * @request GET:/v1/message/{chatId}
     * @secure
     */
    messageControllerGetChatByChatId: (chatId: string, params: RequestParams = {}) =>
      this.request<ChatGetViewModel, void>({
        path: `/v1/message/${chatId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags message
     * @name MessageControllerGetMessagesByChatId
     * @summary Get all messages from chat with chat id
     * @request GET:/v1/message/{chatId}/messages/
     * @secure
     */
    messageControllerGetMessagesByChatId: (chatId: string, params: RequestParams = {}) =>
      this.request<MessageListViewModel, void>({
        path: `/v1/message/${chatId}/messages/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags message
     * @name MessageControllerGetAllChats
     * @summary Get all chats
     * @request GET:/v1/message/chat/all
     * @secure
     */
    messageControllerGetAllChats: (params: RequestParams = {}) =>
      this.request<ChatGetViewModel[], any>({
        path: `/v1/message/chat/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags message
     * @name MessageControllerCreateNewChat
     * @summary Creates a new chat and returns newly created ChatDocument
     * @request POST:/v1/message
     * @secure
     */
    messageControllerCreateNewChat: (data: CreateChatDto, params: RequestParams = {}) =>
      this.request<ChatGetViewModel, void>({
        path: `/v1/message`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags message
     * @name MessageControllerAddUsersToChat
     * @summary Adds a set of users to a chat
     * @request PUT:/v1/message/{chatId}/addUser
     * @secure
     */
    messageControllerAddUsersToChat: (chatId: string, data: UpdateOwnersDto, params: RequestParams = {}) =>
      this.request<ChatPutViewModel, void>({
        path: `/v1/message/${chatId}/addUser`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags message
     * @name MessageControllerRemoveUsersFromChat
     * @summary Removes a set of users from the chat
     * @request PUT:/v1/message/{chatId}/removeUser
     * @secure
     */
    messageControllerRemoveUsersFromChat: (chatId: string, data: UpdateOwnersDto, params: RequestParams = {}) =>
      this.request<ChatPutViewModel, void>({
        path: `/v1/message/${chatId}/removeUser`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags message
     * @name MessageControllerAddMessageToChat
     * @summary Adds a message to a chat
     * @request PUT:/v1/message/{chatId}/addMessage
     * @secure
     */
    messageControllerAddMessageToChat: (chatId: string, data: AddMessageToChatDto, params: RequestParams = {}) =>
      this.request<MessageViewModel, void>({
        path: `/v1/message/${chatId}/addMessage`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags message
     * @name MessageControllerDeleteChat
     * @summary Deletes chat with chatId
     * @request DELETE:/v1/message/{chatId}/chat
     * @secure
     */
    messageControllerDeleteChat: (chatId: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/v1/message/${chatId}/chat`,
        method: "DELETE",
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerInvite
     * @summary Creates an new user and send invitation email to new user. You need Admin Access.
     * @request POST:/v1/user/invite/asAdmin
     * @secure
     */
    userControllerInvite: (data: CreateUserDto, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/v1/user/invite/asAdmin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerFind
     * @summary Get an user by auth info
     * @request GET:/v1/user
     * @secure
     */
    userControllerFind: (params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/v1/user`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerFindall
     * @summary Get all users
     * @request GET:/v1/user/all
     * @secure
     */
    userControllerFindall: (params: RequestParams = {}) =>
      this.request<UserDocument[], void>({
        path: `/v1/user/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerFindOne
     * @summary Get an user by id
     * @request GET:/v1/user/{id}
     * @secure
     */
    userControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/v1/user/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerUpdate
     * @summary Update a user by id
     * @request PATCH:/v1/user/{id}
     * @secure
     */
    userControllerUpdate: (id: string, data: UpdateUserDto, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/v1/user/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerFindByAuthInfo
     * @summary Get an user by auth info id
     * @request GET:/v1/user/{id}/username
     * @secure
     */
    userControllerFindByAuthInfo: (id: string, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/v1/user/${id}/username`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerAddRole
     * @summary Promote a user by id
     * @request PATCH:/v1/user/{id}/role/add
     * @secure
     */
    userControllerAddRole: (id: string, data: UserRoleDto, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/v1/user/${id}/role/add`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerRemoveRole
     * @summary Demote a user by id
     * @request PATCH:/v1/user/{id}/role/remove
     * @secure
     */
    userControllerRemoveRole: (id: string, data: UserRoleDto, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/v1/user/${id}/role/remove`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerAddPermission
     * @summary Add a permission to a user by id
     * @request PATCH:/v1/user/{id}/permission/add
     * @secure
     */
    userControllerAddPermission: (id: string, data: UserPermissionDto, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/v1/user/${id}/permission/add`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerRemovePermission
     * @summary Removes a permission for a user by id
     * @request PATCH:/v1/user/{id}/permission/remove
     * @secure
     */
    userControllerRemovePermission: (id: string, data: UserPermissionDto, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/v1/user/${id}/permission/remove`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerDelete
     * @summary Deletes a User by Id
     * @request DELETE:/v1/user/{id}/delete
     * @secure
     */
    userControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/v1/user/${id}/delete`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerSignIn
     * @request POST:/v1/auth/signin
     */
    authControllerSignIn: (data: UserAuthDto, params: RequestParams = {}) =>
      this.request<AuthAccessToken, any>({
        path: `/v1/auth/signin`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerSignOut
     * @request GET:/v1/auth/signOut
     * @secure
     */
    authControllerSignOut: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/auth/signOut`,
        method: "GET",
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerRefresh
     * @request POST:/v1/auth/refresh
     */
    authControllerRefresh: (data: GetTokenByRefreshTokenDto, params: RequestParams = {}) =>
      this.request<AuthAccessToken, any>({
        path: `/v1/auth/refresh`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerVerify
     * @request POST:/v1/auth/verifyEmail
     */
    authControllerVerify: (data: VerifyAuthDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/auth/verifyEmail`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerConfirmPassword
     * @request POST:/v1/auth/confirmPassword
     * @secure
     */
    authControllerConfirmPassword: (data: ConfirmPasswordDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/auth/confirmPassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerChangePassword
     * @request POST:/v1/auth/changePassword
     * @secure
     */
    authControllerChangePassword: (data: ChangePasswordDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/auth/changePassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerChangePasswordIfRequired
     * @request POST:/v1/auth/changePasswordIfRequired
     */
    authControllerChangePasswordIfRequired: (data: ChangePasswordIfRequiredDto, params: RequestParams = {}) =>
      this.request<AuthAccessToken, any>({
        path: `/v1/auth/changePasswordIfRequired`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerForgotPassword
     * @request POST:/v1/auth/forgotPassword
     */
    authControllerForgotPassword: (data: ForgotPasswordDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/auth/forgotPassword`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags image
     * @name ImageControllerFindAll
     * @summary Get all images
     * @request GET:/v1/image
     * @secure
     */
    imageControllerFindAll: (params: RequestParams = {}) =>
      this.request<ImageDocument, void>({
        path: `/v1/image`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags image
     * @name ImageControllerFindOne
     * @summary Get an image by id
     * @request GET:/v1/image/{id}
     * @secure
     */
    imageControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<ImageDocument, void>({
        path: `/v1/image/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags image
     * @name ImageControllerRemove
     * @summary Delete a image by id
     * @request DELETE:/v1/image/{id}
     * @secure
     */
    imageControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<ImageDocument, void>({
        path: `/v1/image/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerCreate
     * @summary Create a new partner
     * @request POST:/v1/partner
     * @secure
     */
    partnerControllerCreate: (data: CreatePartnerDto, params: RequestParams = {}) =>
      this.request<CreatePartnerDto, void>({
        path: `/v1/partner`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerFindAll
     * @summary Get all partners
     * @request GET:/v1/partner
     * @secure
     */
    partnerControllerFindAll: (params: RequestParams = {}) =>
      this.request<PartnerDocument[], void>({
        path: `/v1/partner`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerFindGeojson
     * @summary Get all partners
     * @request GET:/v1/partner/geojson
     * @secure
     */
    partnerControllerFindGeojson: (params: RequestParams = {}) =>
      this.request<PartnerGeojsonViewmodel, void>({
        path: `/v1/partner/geojson`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerFindOne
     * @summary Get an partner by id
     * @request GET:/v1/partner/{id}
     * @secure
     */
    partnerControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<PartnerDocument, void>({
        path: `/v1/partner/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerUpdate
     * @summary Update a partner by id
     * @request PATCH:/v1/partner/{id}
     * @secure
     */
    partnerControllerUpdate: (id: string, data: UpdatePartnerDto, params: RequestParams = {}) =>
      this.request<PartnerDocument, void>({
        path: `/v1/partner/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerRemove
     * @summary Delete a partner by id
     * @request DELETE:/v1/partner/{id}
     * @secure
     */
    partnerControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<PartnerDocument, void>({
        path: `/v1/partner/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerFindByName
     * @summary Get a partner by name
     * @request GET:/v1/partner/{partnerName}/byName
     */
    partnerControllerFindByName: (partnerName: string, params: RequestParams = {}) =>
      this.request<PartnerDocument, void>({
        path: `/v1/partner/${partnerName}/byName`,
        method: "GET",
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerFindByNameGeocode
     * @summary Get a partner by location search string
     * @request GET:/v1/partner/{searchstring}/byLocation
     * @secure
     */
    partnerControllerFindByNameGeocode: (
      searchstring: string,
      query?: { maxDistance?: number },
      params: RequestParams = {}
    ) =>
      this.request<PartnerDocument, void>({
        path: `/v1/partner/${searchstring}/byLocation`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerFindByUrl
     * @summary Get a partner by url
     * @request GET:/v1/partner/{url}/byUrl
     */
    partnerControllerFindByUrl: (url: string, params: RequestParams = {}) =>
      this.request<PartnerDocument, void>({
        path: `/v1/partner/${url}/byUrl`,
        method: "GET",
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags form
     * @name FormControllerCreate
     * @summary Submit contact form to contact a Partner.
     * @request POST:/v1/partner/{partnerName}/contact
     */
    formControllerCreate: (partnerName: string, data: CreateFormDto, params: RequestParams = {}) =>
      this.request<FormDocument, void>({
        path: `/v1/partner/${partnerName}/contact`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags form
     * @name FormControllerFindAll
     * @summary Get all forms
     * @request GET:/v1/partner/{id}/contact
     * @secure
     */
    formControllerFindAll: (id: string, params: RequestParams = {}) =>
      this.request<FormDocument[], void>({
        path: `/v1/partner/${id}/contact`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags form
     * @name FormControllerFindOne
     * @summary Get a form by id
     * @request GET:/v1/partner/{partnerId}/contact/{formId}
     * @secure
     */
    formControllerFindOne: (partnerId: string, formId: string, params: RequestParams = {}) =>
      this.request<FormDocument, void>({
        path: `/v1/partner/${partnerId}/contact/${formId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags form
     * @name FormControllerExportOne
     * @summary Export a form by id
     * @request GET:/v1/partner/{partnerId}/contact/{formId}/export/{exportType}
     * @secure
     */
    formControllerExportOne: (partnerId: string, formId: string, exportType: string, params: RequestParams = {}) =>
      this.request<ExportResultViewModel, void>({
        path: `/v1/partner/${partnerId}/contact/${formId}/export/${exportType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags form
     * @name FormControllerAddRegistration
     * @summary Add an registration details to a form
     * @request POST:/v1/partner/{partnerId}/contact/{formId}/registration
     * @secure
     */
    formControllerAddRegistration: (
      partnerId: string,
      formId: string,
      data: RegistrationDto,
      params: RequestParams = {}
    ) =>
      this.request<FormDocument, void>({
        path: `/v1/partner/${partnerId}/contact/${formId}/registration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags products
     * @name ProductControllerCreate
     * @summary Create an Prodcut for an Partner (ADMIN access)
     * @request POST:/v1/partner/{partnerId}/product
     * @secure
     */
    productControllerCreate: (
      partnerId: string,
      data: CreateProductDto,
      query?: { validate?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<ProductDocument, any>({
        path: `/v1/partner/${partnerId}/product`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags products
     * @name ProductControllerGetByPartner
     * @summary Retrieve all Prodcuts of a Partner (OPEN access)
     * @request GET:/v1/partner/{partnerId}/product
     */
    productControllerGetByPartner: (partnerId: string, params: RequestParams = {}) =>
      this.request<ProductViewmodel[], any>({
        path: `/v1/partner/${partnerId}/product`,
        method: "GET",
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags products
     * @name ProductControllerDeleteByProductId
     * @summary Deacticates an Prodcut of a Partner (ADMIN access)
     * @request GET:/v1/partner/{partnerId}/product/{productId}/deactivate
     * @secure
     */
    productControllerDeleteByProductId: (partnerId: string, productId: string, params: RequestParams = {}) =>
      this.request<ProductDocument, any>({
        path: `/v1/partner/${partnerId}/product/${productId}/deactivate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags products
     * @name ProductControllerGetById
     * @summary Retrieve a single Product of a Partner (ADMIN access)
     * @request GET:/v1/partner/{partnerId}/product/{productId}
     * @secure
     */
    productControllerGetById: (partnerId: string, productId: string, params: RequestParams = {}) =>
      this.request<ProductDocument, any>({
        path: `/v1/partner/${partnerId}/product/${productId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags pdf
     * @name PdfControllerFindAll
     * @summary Get all pdfs
     * @request GET:/v1/pdf
     * @secure
     */
    pdfControllerFindAll: (params: RequestParams = {}) =>
      this.request<PdfDocument, void>({
        path: `/v1/pdf`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags pdf
     * @name PdfControllerFindOne
     * @summary Get an pdf by id
     * @request GET:/v1/pdf/{id}
     * @secure
     */
    pdfControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<PdfDocument, void>({
        path: `/v1/pdf/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags pdf
     * @name PdfControllerRemove
     * @summary Delete a pdf by id
     * @request DELETE:/v1/pdf/{id}
     * @secure
     */
    pdfControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<PdfDocument, void>({
        path: `/v1/pdf/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags report
     * @name ReportControllerUploadImage
     * @summary Submit image for a Report.
     * @request POST:/v1/partner/{partnerName}/report/image
     */
    reportControllerUploadImage: (partnerName: string, data: CreateReportImageDto, params: RequestParams = {}) =>
      this.request<CreatedImageFromReportResponseDto, void>({
        path: `/v1/partner/${partnerName}/report/image`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags report
     * @name ReportControllerCreate
     * @summary Submit report form to contact a Partner.
     * @request POST:/v1/partner/{partnerName}/report
     */
    reportControllerCreate: (
      partnerName: string,
      data: CreateReportDto,
      query?: { validate?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<ReportDocument, void>({
        path: `/v1/partner/${partnerName}/report`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags report
     * @name ReportControllerFindAll
     * @summary Get all reports
     * @request GET:/v1/partner/{partnerId}/report
     * @secure
     */
    reportControllerFindAll: (partnerId: string, params: RequestParams = {}) =>
      this.request<ReportDocument[], void>({
        path: `/v1/partner/${partnerId}/report`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags report
     * @name ReportControllerFindOne
     * @summary Get a report by id
     * @request GET:/v1/partner/{partnerId}/report/{reportId}
     * @secure
     */
    reportControllerFindOne: (partnerId: string, reportId: string, params: RequestParams = {}) =>
      this.request<ReportDocument, void>({
        path: `/v1/partner/${partnerId}/report/${reportId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags report
     * @name ReportControllerAddRegistration
     * @summary Add an registration details to a report
     * @request POST:/v1/partner/{partnerId}/report/{reportId}/registration
     * @secure
     */
    reportControllerAddRegistration: (
      partnerId: string,
      reportId: string,
      data: RegistrationDto,
      params: RequestParams = {}
    ) =>
      this.request<ReportDocument, void>({
        path: `/v1/partner/${partnerId}/report/${reportId}/registration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags report
     * @name ReportControllerExportOne
     * @summary Get the export of a report
     * @request GET:/v1/partner/{partnerId}/report/{reportId}/export/{exportType}
     * @secure
     */
    reportControllerExportOne: (partnerId: string, reportId: string, exportType: string, params: RequestParams = {}) =>
      this.request<ExportResultViewModel, void>({
        path: `/v1/partner/${partnerId}/report/${reportId}/export/${exportType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags newsletter
     * @name NewsletterControllerCreate
     * @summary Suscribe for newsletter.
     * @request POST:/v1/newsletter
     */
    newsletterControllerCreate: (data: CreateNewsletterDto, params: RequestParams = {}) =>
      this.request<OptInConfirmation, void>({
        path: `/v1/newsletter`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags newsletter
     * @name NewsletterControllerFindAll
     * @summary Get all newsletter
     * @request GET:/v1/newsletter
     * @secure
     */
    newsletterControllerFindAll: (params: RequestParams = {}) =>
      this.request<NewsletterDocument[], void>({
        path: `/v1/newsletter`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags newsletter
     * @name NewsletterControllerFind
     * @summary Get an newsletter by id
     * @request GET:/v1/newsletter/{id}
     * @secure
     */
    newsletterControllerFind: (id: string, params: RequestParams = {}) =>
      this.request<NewsletterDocument, void>({
        path: `/v1/newsletter/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags newsletter
     * @name NewsletterControllerDeleteEditor
     * @summary Delete newsletter by id
     * @request DELETE:/v1/newsletter/{id}
     * @secure
     */
    newsletterControllerDeleteEditor: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/v1/newsletter/${id}`,
        method: "DELETE",
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags newsletter
     * @name NewsletterControllerVerify
     * @summary Verify newslettersubsrciption.
     * @request GET:/v1/newsletter/{id}/verify/{key}
     */
    newsletterControllerVerify: (id: string, key: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/v1/newsletter/${id}/verify/${key}`,
        method: "GET",
        ...params
      }),

    /**
     * No description
     *
     * @tags newsletter
     * @name NewsletterControllerUnsubscribe
     * @summary Unsubscribe from newsletter
     * @request GET:/v1/newsletter/{id}/unsubscribe/{key}
     */
    newsletterControllerUnsubscribe: (id: string, key: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/v1/newsletter/${id}/unsubscribe/${key}`,
        method: "GET",
        ...params
      }),

    /**
     * No description
     *
     * @tags newsletter
     * @name NewsletterControllerMailOpend
     * @summary Tracks when the mail is opened.
     * @request GET:/v1/newsletter/{id}/mailopend/{key}
     */
    newsletterControllerMailOpend: (id: string, key: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/v1/newsletter/${id}/mailopend/${key}`,
        method: "GET",
        ...params
      }),

    /**
     * No description
     *
     * @tags analytics
     * @name AnalyticsControllerCount
     * @summary Count the number of Documents in a specific Collection.
     * @request GET:/v1/analytics/count
     * @secure
     */
    analyticsControllerCount: (
      query: {
        document: "form" | "report" | "image" | "user" | "partner" | "newsletter" | "appraisal";
        from: string;
        to: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsCount[], void>({
        path: `/v1/analytics/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags analytics
     * @name AnalyticsControllerCoundAndGroupByPartner
     * @summary Count the number of Documents in a specific Collection grouped by partners if possible.
     * @request GET:/v1/analytics/count/group
     * @secure
     */
    analyticsControllerCoundAndGroupByPartner: (
      query: { document: "form" | "report" | "image" | "user" | "partner" | "newsletter" | "appraisal" },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsCountGroupByPartner[], void>({
        path: `/v1/analytics/count/group`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * @description Use this endpoint to submit an appraisal to mmmint.ai. After a check, the appraisal is forwarded to one of our partners. Endpoint is limited to 20 requests per Minute.
     *
     * @tags appraisal
     * @name AppraisalControllerCreate
     * @summary Submit appraisal (APPRAISAL access)
     * @request POST:/v1/appraisal
     * @secure
     */
    appraisalControllerCreate: (data: CreateAppraisalDto, query?: { validate?: boolean }, params: RequestParams = {}) =>
      this.request<AppraisalIdViewmodel, void>({
        path: `/v1/appraisal`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags appraisal
     * @name AppraisalControllerFindAll
     * @summary Find all Appraisals (ADMIN access)
     * @request GET:/v1/appraisal
     * @secure
     */
    appraisalControllerFindAll: (query?: { validate?: boolean }, params: RequestParams = {}) =>
      this.request<AppraisalViewmodel[], void>({
        path: `/v1/appraisal`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags appraisal
     * @name AppraisalControllerNotify
     * @summary Notify a Partner to work on an appraisal (ADMIN access).
     * @request POST:/v1/appraisal/{appraisalId}/notifypartner
     * @secure
     */
    appraisalControllerNotify: (
      appraisalId: string,
      data: AppraisalNotifyPartnerDto,
      query?: { validate?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<AppraisalIdViewmodel, void>({
        path: `/v1/appraisal/${appraisalId}/notifypartner`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags appraisal
     * @name AppraisalControllerFind
     * @summary Find a specific Appraisals (ADMIN access)
     * @request GET:/v1/appraisal/{appraisalId}
     * @secure
     */
    appraisalControllerFind: (appraisalId: string, query?: { validate?: boolean }, params: RequestParams = {}) =>
      this.request<AppraisalViewmodel, void>({
        path: `/v1/appraisal/${appraisalId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags appraisal
     * @name AppraisalControllerFindAllByPartner
     * @summary Find all Appraisals (PARTNER access)
     * @request GET:/v1/partner/{partnerId}/appraisal
     * @secure
     */
    appraisalControllerFindAllByPartner: (
      partnerId: string,
      query?: { validate?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<AppraisalViewmodel[], void>({
        path: `/v1/partner/${partnerId}/appraisal`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags appraisal
     * @name AppraisalControllerFindOneWithPartner
     * @summary Find a specific Appraisals (PARTNER access)
     * @request GET:/v1/partner/{partnerId}/appraisal/{appraisalId}
     * @secure
     */
    appraisalControllerFindOneWithPartner: (
      appraisalId: string,
      partnerId: string,
      query?: { validate?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<AppraisalViewmodel, void>({
        path: `/v1/partner/${partnerId}/appraisal/${appraisalId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags payment
     * @name PaymentControllerPayment
     * @request POST:/v1/partner/{partnerId}/payment
     */
    paymentControllerPayment: (partnerId: string, data: PaymentDto, params: RequestParams = {}) =>
      this.request<PaymentViewmodel, any>({
        path: `/v1/partner/${partnerId}/payment`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags payment
     * @name PaymentControllerStripeChange
     * @request POST:/v1/payment/webhook
     */
    paymentControllerStripeChange: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/payment/webhook`,
        method: "POST",
        ...params
      }),

    /**
     * No description
     *
     * @tags manufacturer
     * @name ManufacturerControllerCreate
     * @summary Create a new manufacturer
     * @request POST:/v1/docphant/manufacturer
     * @secure
     */
    manufacturerControllerCreate: (data: ManufacturerDto, params: RequestParams = {}) =>
      this.request<ManufacturerViewmodel, void>({
        path: `/v1/docphant/manufacturer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags manufacturer
     * @name ManufacturerControllerFindAll
     * @summary Retrieves all manufacturer
     * @request GET:/v1/docphant/manufacturer
     * @secure
     */
    manufacturerControllerFindAll: (params: RequestParams = {}) =>
      this.request<ManufacturerViewmodel[], void>({
        path: `/v1/docphant/manufacturer`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags manufacturer
     * @name ManufacturerControllerFindOne
     * @summary Retrieve a manufacturer
     * @request GET:/v1/docphant/manufacturer/{id}
     * @secure
     */
    manufacturerControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<ManufacturerViewmodel, void>({
        path: `/v1/docphant/manufacturer/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags manufacturer
     * @name ManufacturerControllerDelete
     * @summary Delete a manufacturer
     * @request DELETE:/v1/docphant/manufacturer/{id}
     * @secure
     */
    manufacturerControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<ManufacturerViewmodel, void>({
        path: `/v1/docphant/manufacturer/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags manufacturer
     * @name ManufacturerControllerUpdate
     * @summary Update a manufacturer
     * @request PATCH:/v1/docphant/manufacturer/{id}
     * @secure
     */
    manufacturerControllerUpdate: (id: string, data: ManufacturerDto, params: RequestParams = {}) =>
      this.request<ManufacturerViewmodel, void>({
        path: `/v1/docphant/manufacturer/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags machine
     * @name MachineControllerCreate
     * @summary Create a new machine
     * @request POST:/v1/docphant/manufacturer/{manufacturerId}/machine
     * @secure
     */
    machineControllerCreate: (manufacturerId: string, data: MachineDto, params: RequestParams = {}) =>
      this.request<MachineViewmodel, void>({
        path: `/v1/docphant/manufacturer/${manufacturerId}/machine`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags machine
     * @name MachineControllerFindAll
     * @summary Retrieves all machine
     * @request GET:/v1/docphant/manufacturer/{manufacturerId}/machine
     * @secure
     */
    machineControllerFindAll: (manufacturerId: string, params: RequestParams = {}) =>
      this.request<MachineViewmodel[], void>({
        path: `/v1/docphant/manufacturer/${manufacturerId}/machine`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags machine
     * @name MachineControllerFindOne
     * @summary Retrieve a machine
     * @request GET:/v1/docphant/manufacturer/{manufacturerId}/machine/{id}
     */
    machineControllerFindOne: (manufacturerId: string, id: string, params: RequestParams = {}) =>
      this.request<MachineViewmodelWithManufacturerAndAttachment, void>({
        path: `/v1/docphant/manufacturer/${manufacturerId}/machine/${id}`,
        method: "GET",
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags machine
     * @name MachineControllerDelete
     * @summary Delete a machine
     * @request DELETE:/v1/docphant/manufacturer/{manufacturerId}/machine/{id}
     * @secure
     */
    machineControllerDelete: (manufacturerId: string, id: string, params: RequestParams = {}) =>
      this.request<MachineViewmodel, void>({
        path: `/v1/docphant/manufacturer/${manufacturerId}/machine/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags machine
     * @name MachineControllerUpdate
     * @summary Update a machine
     * @request PATCH:/v1/docphant/manufacturer/{manufacturerId}/machine/{id}
     * @secure
     */
    machineControllerUpdate: (manufacturerId: string, id: string, data: MachineDto, params: RequestParams = {}) =>
      this.request<MachineViewmodel, void>({
        path: `/v1/docphant/manufacturer/${manufacturerId}/machine/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags machine
     * @name MachineControllerAddMachineAttachment
     * @summary Connects a documentation to a machine
     * @request POST:/v1/docphant/manufacturer/{manufacturerId}/machine/{id}/documentation/add
     * @secure
     */
    machineControllerAddMachineAttachment: (
      manufacturerId: string,
      id: string,
      data: AddMachineAttachmentDto,
      params: RequestParams = {}
    ) =>
      this.request<MachineViewmodelWithManufacturer, void>({
        path: `/v1/docphant/manufacturer/${manufacturerId}/machine/${id}/documentation/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags machine
     * @name MachineControllerRemoveMachineAttachment
     * @summary Removes a documentation to a machine
     * @request POST:/v1/docphant/manufacturer/{manufacturerId}/machine/{id}/documentation/remove
     * @secure
     */
    machineControllerRemoveMachineAttachment: (
      manufacturerId: string,
      id: string,
      data: AddMachineAttachmentDto,
      params: RequestParams = {}
    ) =>
      this.request<MachineViewmodelWithManufacturer, void>({
        path: `/v1/docphant/manufacturer/${manufacturerId}/machine/${id}/documentation/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags machine-attachment
     * @name MachineAttachmentControllerCreate
     * @summary Create a new machine-attachment
     * @request POST:/v1/docphant/manufacturer/{manufacturerId}/machine-attachment
     * @secure
     */
    machineAttachmentControllerCreate: (
      manufacturerId: string,
      data: MachineAttachmentDto,
      params: RequestParams = {}
    ) =>
      this.request<MachineAttachmentViewmodel, void>({
        path: `/v1/docphant/manufacturer/${manufacturerId}/machine-attachment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags machine-attachment
     * @name MachineAttachmentControllerFindAll
     * @summary Retrieves all machine-attachments
     * @request GET:/v1/docphant/manufacturer/{manufacturerId}/machine-attachment
     * @secure
     */
    machineAttachmentControllerFindAll: (manufacturerId: string, params: RequestParams = {}) =>
      this.request<MachineAttachmentViewmodel[], void>({
        path: `/v1/docphant/manufacturer/${manufacturerId}/machine-attachment`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags machine-attachment
     * @name MachineAttachmentControllerFindOne
     * @summary Retrieve a machine-attachment
     * @request GET:/v1/docphant/manufacturer/{manufacturerId}/machine-attachment/{id}
     * @secure
     */
    machineAttachmentControllerFindOne: (manufacturerId: string, id: string, params: RequestParams = {}) =>
      this.request<MachineAttachmentViewmodel, void>({
        path: `/v1/docphant/manufacturer/${manufacturerId}/machine-attachment/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags machine-attachment
     * @name MachineAttachmentControllerDelete
     * @summary Delete a machine-attachment
     * @request DELETE:/v1/docphant/manufacturer/{manufacturerId}/machine-attachment/{id}
     * @secure
     */
    machineAttachmentControllerDelete: (id: string, manufacturerId: string, params: RequestParams = {}) =>
      this.request<MachineAttachmentViewmodel, void>({
        path: `/v1/docphant/manufacturer/${manufacturerId}/machine-attachment/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params
      })
  };

  user = {
    /**
     * No description
     *
     * @tags user
     * @name UserControllerCreate
     * @summary Create a new user
     * @request POST:/user
     * @secure
     */
    userControllerCreate: (data: CreateUserDto, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/user`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerFind
     * @summary Get an user by auth info
     * @request GET:/user
     * @secure
     */
    userControllerFind: (params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/user`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerFindOne
     * @summary Get an user by id
     * @request GET:/user/{id}
     * @secure
     */
    userControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/user/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerUpdate
     * @summary Update a user by id
     * @request PATCH:/user/{id}
     * @secure
     */
    userControllerUpdate: (id: string, data: UpdateUserDto, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/user/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerFindByAuthInfo
     * @summary Get an user by auth info id
     * @request GET:/user/{id}/username
     * @secure
     */
    userControllerFindByAuthInfo: (id: string, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/user/${id}/username`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerPromote
     * @summary Promote a user by id
     * @request PATCH:/user/{id}/promote
     * @secure
     */
    userControllerPromote: (id: string, data: PromoteUserDto, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/user/${id}/promote`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserControllerSettype
     * @summary Set the usertype of user by id
     * @request PATCH:/user/{id}/type
     * @secure
     */
    userControllerSettype: (id: string, data: SetUserTypeDto, params: RequestParams = {}) =>
      this.request<UserDocument, void>({
        path: `/user/${id}/type`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
  partner = {
    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerCreate
     * @summary Create a new partner
     * @request POST:/partner
     * @secure
     */
    partnerControllerCreate: (data: CreatePartnerDto, params: RequestParams = {}) =>
      this.request<CreatePartnerDto, void>({
        path: `/partner`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerFindAll
     * @summary Get all partners
     * @request GET:/partner
     * @secure
     */
    partnerControllerFindAll: (params: RequestParams = {}) =>
      this.request<PartnerDocument[], void>({
        path: `/partner`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerFindOne
     * @summary Get an partner by id
     * @request GET:/partner/{id}
     * @secure
     */
    partnerControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<PartnerDocument, void>({
        path: `/partner/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerUpdate
     * @summary Update a partner by id
     * @request PATCH:/partner/{id}
     * @secure
     */
    partnerControllerUpdate: (id: string, data: UpdatePartnerDto, params: RequestParams = {}) =>
      this.request<PartnerDocument, void>({
        path: `/partner/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerRemove
     * @summary Delete a partner by id
     * @request DELETE:/partner/{id}
     * @secure
     */
    partnerControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<PartnerDocument, void>({
        path: `/partner/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerFindByName
     * @summary Get a partner by name
     * @request GET:/partner/{partnerName}/byName
     */
    partnerControllerFindByName: (partnerName: string, params: RequestParams = {}) =>
      this.request<PartnerDocument, void>({
        path: `/partner/${partnerName}/byName`,
        method: "GET",
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerAddEditor
     * @summary Add an editor to a partner.
     * @request POST:/partner/{id}/editor
     * @secure
     */
    partnerControllerAddEditor: (id: string, data: UpdatePartnerEditorDto, params: RequestParams = {}) =>
      this.request<PartnerDocument, void>({
        path: `/partner/${id}/editor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags partner
     * @name PartnerControllerDeleteEditor
     * @summary Delete an editor from a partner
     * @request DELETE:/partner/{id}/editor
     * @secure
     */
    partnerControllerDeleteEditor: (id: string, data: UpdatePartnerEditorDto, params: RequestParams = {}) =>
      this.request<PartnerDocument, void>({
        path: `/partner/${id}/editor`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags form
     * @name FormControllerCreate
     * @summary Submit contact form to contact a Partner.
     * @request POST:/partner/{partnerName}/contact
     */
    formControllerCreate: (partnerName: string, data: CreateFormDto, params: RequestParams = {}) =>
      this.request<FormDocument, void>({
        path: `/partner/${partnerName}/contact`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags form
     * @name FormControllerFindAll
     * @summary Get all forms
     * @request GET:/partner/{id}/contact
     * @secure
     */
    formControllerFindAll: (id: string, params: RequestParams = {}) =>
      this.request<FormDocument[], void>({
        path: `/partner/${id}/contact`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags form
     * @name FormControllerFindOne
     * @summary Get a form by id
     * @request GET:/partner/{partnerId}/contact/{formId}
     * @secure
     */
    formControllerFindOne: (partnerId: string, formId: string, params: RequestParams = {}) =>
      this.request<FormDocument, void>({
        path: `/partner/${partnerId}/contact/${formId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags form
     * @name FormControllerAddRegistration
     * @summary Add an registration details to a form
     * @request POST:/partner/{partnerId}/contact/{formId}/registration
     * @secure
     */
    formControllerAddRegistration: (
      partnerId: string,
      formId: string,
      data: RegistrationDto,
      params: RequestParams = {}
    ) =>
      this.request<FormDocument, void>({
        path: `/partner/${partnerId}/contact/${formId}/registration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags report
     * @name ReportControllerUploadImage
     * @summary Submit image for a Report.
     * @request POST:/partner/{partnerName}/report/image
     */
    reportControllerUploadImage: (partnerName: string, data: CreateReportImageDto, params: RequestParams = {}) =>
      this.request<CreatedImageFromReportResponseDto, void>({
        path: `/partner/${partnerName}/report/image`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags report
     * @name ReportControllerCreate
     * @summary Submit report form to contact a Partner.
     * @request POST:/partner/{partnerName}/report
     */
    reportControllerCreate: (
      partnerName: string,
      data: CreateReportDto,
      query?: { validate?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<ReportDocument, void>({
        path: `/partner/${partnerName}/report`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags report
     * @name ReportControllerFindAll
     * @summary Get all reports
     * @request GET:/partner/{partnerId}/report
     * @secure
     */
    reportControllerFindAll: (partnerId: string, params: RequestParams = {}) =>
      this.request<ReportDocument[], void>({
        path: `/partner/${partnerId}/report`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags report
     * @name ReportControllerFindOne
     * @summary Get a report by id
     * @request GET:/partner/{partnerId}/report/{reportId}
     * @secure
     */
    reportControllerFindOne: (partnerId: string, reportId: string, params: RequestParams = {}) =>
      this.request<ReportDocument, void>({
        path: `/partner/${partnerId}/report/${reportId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @tags report
     * @name ReportControllerAddRegistration
     * @summary Add an registration details to a report
     * @request POST:/partner/{partnerId}/report/{reportId}/registration
     * @secure
     */
    reportControllerAddRegistration: (
      partnerId: string,
      reportId: string,
      data: RegistrationDto,
      params: RequestParams = {}
    ) =>
      this.request<ReportDocument, void>({
        path: `/partner/${partnerId}/report/${reportId}/registration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
}
